export const RtcConfiguration = {
    iceServers: [
        {
            urls: ["turn:trustkeys.network:3478?transport=udp"],
            username: "trustkeys",
            credential: "123456"
        },
        { urls: "stun:stun.1.google.com:19302" },
    ],
}

export const wsURL = "wss://wssdev2.trustkeys.network/wsdev"
// export const wsURL = "ws://localhost:5000/wsdev"


export const getWSCallServerURL = () => {
    const url =  process.env.REACT_APP_WSS_CALL_SERVER
    if(url){
        return url
    }
    return wsURL
}